import React from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useEffect } from "react";
import { initAccordions } from "flowbite";
import Leftsidebar from "../components/sidebar/leftsidebar"
import LeftResponsivesidebar from "../components/sidebar/left-responsive"
import Rightsidebar from "../components/sidebar/rightsidebar"
import RightResponsivesidebar from "../components/sidebar/right-responsive"
import Headmenu from "../components/sidebar/headmenu"
import { useState } from "react";
import { Switch } from "@headlessui/react";
import { ChevronUp } from "lucide-react";
import userimg from "../assets/user.png";
import { X, Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
const AccordionItem = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="policy-title border border-gray-200 rounded-lg overflow-hidden">
            <button
                className="flex justify-between items-center w-full p-5 text-gray-700 bg-white hover:bg-gray-200"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="text-left w-full">{title}</span>
                <ChevronUp className={`h-5 w-5 ChevronUp transition-transform ${isOpen ? "rotate-180" : "rotate-0"}`} />
            </button>
            {isOpen && (
                <div className="p-5 bg-white border-t border-gray-200">
                    {children}
                </div>
            )}
        </div>
    );
};

export default function Account() {

    useEffect(() => {
        initAccordions();
    }, []);

    const [isPrivate, setIsPrivate] = useState(false);
    const [isTwoFactorEnabled, setIsTwoFactorEnabled] = useState(false);
    const [isOpen, setIsOpen] = useState(true);
    const [isTwoFactorOpen, setIsTwoFactorOpen] = useState(true);
    const [isBlockedOpen, setIsBlockedOpen] = useState(true);
    const [isPrivacyOpen, setIsPrivacyOpen] = useState(true);
    const [isPolicyOpen, setIsPolicyOpen] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("+91 79043 30323");
    const [showOTPModal, setShowOTPModal] = useState(false);
    const [selectedMethod, setSelectedMethod] = useState("email"); // Default: email
    const [code, setCode] = useState("");
    const [timer, setTimer] = useState(300); // 5 minutes (300 seconds)
    const navigate = useNavigate(); // Hook for navigation
    const [formData, setFormData] = useState({

        mobile: "",
        countryCode: "+91", // Default country code
    });
    // Format time as MM:SS
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
    };
    const handleSendMobileOTP = async (e) => {
        e.preventDefault();

        if (!formData.mobile) {
            alert("Please enter your mobile number.");
            return;
        }

        const formattedMobile = `${formData.countryCode}-${formData.mobile}`;

        const requestData = { mobile_number: formattedMobile };

        try {
            const response = await fetch("https://pipaan.com360degree.com/api/auth/send-otp", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const data = await response.json();
            if (response.ok && data.success) {
                alert(`OTP has been sent to your mobile number: ${formattedMobile}`);
            } else {
                alert(`Failed to send OTP: ${data.result?.message || "Please try again."}`);
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Something went wrong. Please try again.");
        }
    };
    const handleSubmitVerify = async (e) => {
        e.preventDefault();
        const storedEmail = sessionStorage.getItem("userEmail");
        if (!storedEmail) {
            alert("No email found. Please sign up again.");
            return;
        }
        const requestData = {
            email: storedEmail,  // Email entered by the user
            otp: code,
            verifying: "mobile_number"    // Verification code entered by the user
        };

        try {
            const response = await fetch("https://pipaan.com360degree.com/api/auth/verify-credential", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                console.log("Verification Successful:", data);
                alert("Verification Successful! Please log in.");

                // Redirect to login page
                navigate("/login");
            } else {
                console.error("Verification Failed:", data);
                alert(`Verification failed: ${data.result?.message || "Invalid code. Please try again."}`);
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Something went wrong. Please try again.");
        }
    };
    const handleGenerateOTP = async (e) => {
        e.preventDefault();

        if (!formData.mobile) {
            alert("Please enter your mobile number.");
            return;
        }

        const formattedMobile = `${formData.countryCode}-${formData.mobile}`;
        const requestData = { mobile_number: formattedMobile };

        try {
            const response = await fetch("https://pipaan.com360degree.com/api/auth/send-otp", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const data = await response.json();
            if (response.ok && data.success) {
                alert(`OTP has been sent to your mobile number: ${formattedMobile}`);
            } else {
                alert(`Failed to send OTP: ${data.result?.message || "Please try again."}`);
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Something went wrong. Please try again.");
        }
    };
    const handleVerifyOTP = async (e) => {
        e.preventDefault();

        if (!formData.mobile) {
            alert("Please enter your mobile number.");
            return;
        }
        if (!code) {
            alert("Please enter the OTP.");
            return;
        }
        const formattedMobile = `${formData.countryCode}-${formData.mobile}`;
        const requestData = {
            email: formattedMobile,  // API expects "email", but we're passing the mobile number
            otp: code,
            verifying: "mobile_number"
            // Include the OTP entered by the user
        };


        try {
            const response = await fetch("https://pipaan.com360degree.com/api/auth/verify-credential", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const data = await response.json();
            if (response.ok && data.success) {
                alert("Verification Successful! Please log in.");
                navigate("/login"); // Redirect after successful verification
            } else {
                alert(`Verification failed: ${data.result?.message || "Invalid code. Please try again."}`);
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Something went wrong. Please try again.");
        }
    };
    return (

        <div className="dashboard w-full min-h-screen  flex">
            {/* Sidebar */}
            <Leftsidebar />


            <main className="flex-1 p-6">
                <LeftResponsivesidebar />
                <Headmenu />
                {/* Main Content */}
                <main className="flex ">

                    {/* Feeds */}
                    <div className="flex-1 lg:pr-5 space-y-6">

                        <div className="account-setting mx-auto ">
                            <div className="mt-6 p-8 bg-[#F4F4F4] rounded-2xl shadow-lg relative">
                                <h2 className="text-lg font-semibold mb-4">Account Settings</h2>
                                <button
                                    className="absolute top-8 right-8 p-1 bg-[#09522869] rounded-full"
                                    onClick={() => setIsOpen(!isOpen)}
                                >
                                    <ChevronUp className={`h-4 w-4 text-[#095228] transition-transform ${isOpen ? "rotate-0" : "rotate-180"}`} />
                                </button>

                                {isOpen && (
                                    <>
                                        <div className="space-y-3">
                                            <span className="text-gray-500 block md:hidden">Phone Number</span>
                                            <div className="bg-white p-5 rounded-[12px] flex justify-between items-center shadow-sm">

                                                <div className="flex">
                                                    <span className="text-gray-500 w-[200px] tab-title">Phone Number</span>
                                                    <div className="text-black font-[400] flex items-center">
                                                        +91 79043 30323 <span className="ml-1 text-green-500">
                                                            <span className="w-4 h-4 bg-green-500 text-white rounded-full flex items-center justify-center">
                                                                <Check className="w-3 h-3" />
                                                            </span></span>
                                                    </div>
                                                </div>
                                                {/* Change Button */}
                                                <button onClick={() => setIsModalOpen(true)} className="text-gray-400 text-sm">
                                                    Change
                                                </button>

                                                {/* Modal */}
                                                {isModalOpen && (
                                                    


                                                    <div className="fixed inset-0 flex items-center justify-center  bg-[#fff] backdrop-blur bg-opacity-50 z-[9999]">
                                                        <div className="bg-white p-6  md:pl-[8%] md:pr-[8%] md:pb-[6%] rounded-2xl shadow-lg relative">
                                                            {/* Close Button */}
                                                            <button
                                                                className="hidden md:block absolute top-6 right-6 text-[#fff] hover:text-[#fff] bg-[#095228] rounded-full p-1 pl-2.5 pr-2.5"
                                                                onClick={() => setIsModalOpen(false)}
                                                            >
                                                                ✖
                                                            </button>
                                                           
                                                            {/* Forgot Password Form */}
                                                            <h2 className="login-title text-base font-medium text-center mt-2 mb-6 ">
                                                                OTP Verification
                                                            </h2>

                                                            <form onSubmit={handleSubmitVerify} className="space-y-4 frg-pass-content">
                                                                
                                                                {/* Conditional Input Field */}
                                                                <div>
                                                                    <label className="text-[14px] text-[#80807F] font-[400] block mt-9 mb-3 text-center">Enter the verification code we just sent to your number +91 94 *******53.&nbsp;
                                                                        {selectedMethod === "email" ? "Email" : "Phone Number"}
                                                                    </label>
                                                                    <input
                                                                        // type={selectedMethod === "email" ? "email" : "tel"}
                                                                        placeholder={selectedMethod === "email" ? "Enter Verification Code" : "Enter Verification Code"}
                                                                        value={code}
                                                                        onChange={(e) => setCode(e.target.value)}
                                                                        className="mb-4 w-full px-3 py-4 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 outline-none"
                                                                        required
                                                                    />
                                                                </div>

                                                                {/* Signup Link */}
                                                                <div className="vrfy-code-valid ">
                                                                    {/* <num className="timer">05.00</num> */}
                                                                    <p className=" text-center text-[18px] text-[#BE1F2E] text-lg font-bold">{formatTime(timer)}</p>

                                                                </div>
                                                                <p className=" text-center text-[18px] text-gray-600 ">
                                                                    Didn’t receive a code?{" "}
                                                                    {/* <Link to="/signup" className="text-[#095228] font-medium hover:underline">
                                                            Resend
                                                          </Link> */}
                                                                    <button
                                                                        onClick={handleSendMobileOTP} // Call new function to resend OTP
                                                                        className="text-[#095228] font-medium hover:underline"
                                                                    >
                                                                        Resend
                                                                    </button>
                                                                </p>
                                                                <button
                                                                    type="submit"
                                                                    onClick={handleVerifyOTP} // Call function to verify OTP

                                                                    className="w-full bg-[#80807F] hover:bg-[#1B2537]/90 text-white py-4 text-[18px] rounded-xl font-medium mb-10"
                                                                >
                                                                    Verify
                                                                </button>
                                                                {/* Close Button */}
                                                                <button
                                                                    className="md:hidden w-full bg-[#161F28] hover:bg-[#1B2537]/90 text-white py-4 rounded-xl font-medium mb-10"
                                                                    onClick={() => setShowOTPModal(false)}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </form>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <span className="text-gray-500 block md:hidden">Email ID</span>
                                            <div className="bg-white p-5 rounded-[12px] flex justify-between items-center shadow-sm">
                                                <div className="flex">
                                                    <span className="text-gray-500  w-[200px] tab-title">Email ID</span>
                                                    <div className="text-black font-[400] flex items-center">
                                                        praveenkumar@carmatec.in <span className="ml-1 text-green-500"><span className="w-4 h-4 bg-green-500 text-white rounded-full flex items-center justify-center">
                                                            <Check className="w-3 h-3" />
                                                        </span></span>
                                                    </div>
                                                </div>
                                                <button className="text-white bg-[#095228] rounded-[20px] py-2 px-4 text-sm">save</button>
                                            </div>
                                            <span className="text-gray-500  block md:hidden">Password</span>
                                            <div className="bg-white p-5 rounded-[12px] flex  items-center shadow-sm">
                                                <span className="text-gray-500  w-[200px] tab-title">Password</span>
                                                <button className="text-black font-[400] underline">Change Password</button>
                                            </div>
                                            <span className="text-gray-500  block md:hidden">Switch to</span>
                                            <div className="bg-white p-5 rounded-[12px] flex  items-center shadow-sm">

                                                <span className="text-gray-500  w-[200px] tab-title">Switch to</span>
                                                <div className="flex items-center space-x-2">
                                                    <span className={`font-[400] ${!isPrivate ? "text-black" : "text-gray-400"}`}>Public Account</span>
                                                    <Switch
                                                        checked={isPrivate}
                                                        onChange={setIsPrivate}
                                                        className={`${isPrivate ? "bg-green-700" : "bg-green-700"} relative inline-flex h-6 w-14 items-center rounded-full transition-all`}
                                                    >
                                                        <span className="inline-block h-4 w-6 ml-1 transform bg-white rounded-full translate-x-1 transition-all" style={{ transform: isPrivate ? "translateX(20px)" : "translateX(0px)" }} />
                                                    </Switch>
                                                    <span className={`font-[400] ${isPrivate ? "text-black" : "text-gray-400"}`}>Private Account</span>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>

                            {/* Two-Factor Authentication Section */}
                            <div className="mt-6 p-8 bg-[#F4F4F4] rounded-2xl shadow-lg relative">
                                <h2 className="text-lg font-semibold mb-4">Two-factor authentication</h2>
                                <button
                                    className="absolute top-8 right-8 p-1 bg-[#09522869] rounded-full"
                                    onClick={() => setIsTwoFactorOpen(!isTwoFactorOpen)}
                                >
                                    <ChevronUp className={`h-4 w-4 text-[#095228] transition-transform ${isTwoFactorOpen ? "rotate-0" : "rotate-180"}`} />
                                </button>
                                {isTwoFactorOpen && (
                                    <><span className="text-gray-500 mb-2 block md:hidden">Authentication</span>
                                        <div className="bg-white p-5 rounded-[12px] flex  items-center shadow-sm">
                                            <span className="text-gray-500 w-[200px] tab-title">Authentication</span>
                                            <div className="flex items-center space-x-2">
                                                <span className={`font-medium ${!isTwoFactorEnabled ? "text-black" : "text-gray-400"}`}>Enable</span>
                                                <Switch
                                                    checked={isTwoFactorEnabled}
                                                    onChange={setIsTwoFactorEnabled}
                                                    className={`${isTwoFactorEnabled ? "bg-green-700" : "bg-green-700"} relative inline-flex h-6 w-14 items-center rounded-full transition-all`}
                                                >
                                                    <span className="inline-block h-4 w-6 ml-1 transform bg-white rounded-full translate-x-1 transition-all" style={{ transform: isTwoFactorEnabled ? "translateX(20px)" : "translateX(0px)" }} />
                                                </Switch>
                                                <span className={`font-medium ${isTwoFactorEnabled ? "text-black" : "text-gray-400"}`}>Disable</span>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                            {/* Blocked Accounts Section */}
                            <div className="mt-6 p-8 bg-[#F4F4F4] rounded-2xl shadow-lg relative">
                                <h2 className="text-lg font-semibold mb-4">Blocked Accounts</h2>
                                <button
                                    className="absolute top-8 right-8 p-1 bg-[#09522869] rounded-full"
                                    onClick={() => setIsBlockedOpen(!isBlockedOpen)}
                                >
                                    <ChevronUp className={`h-4 w-4 text-[#095228] transition-transform ${isBlockedOpen ? "rotate-0" : "rotate-180"}`} />
                                </button>
                                {isBlockedOpen && (
                                    <>

                                        <div className="space-y-3">
                                            {[1, 2, 3].map((id) => (
                                                <div key={id} className="bg-white p-5 rounded-[12px] flex justify-between items-center shadow-sm">
                                                    <div className="flex">
                                                        <img src={userimg} alt="User" className="w-12 h-12 rounded-full" />
                                                        <div className="pl-4">
                                                            <p className="titlesemibold font-semibold pb-1">Marketing Group</p>
                                                            <p className="text-[12px] text-[#747474] pb-1">
                                                                @prvnk_sky
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <button className="text-[#BE1F2E] font-semibold border border-[#BE1F2E]  px-3 py-1 rounded-full">Unblock</button>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}
                            </div>
                            {/* Privacy Centre Section */}
                            <div className="mt-6 p-8 bg-[#F4F4F4] rounded-2xl shadow-lg relative">
                                <h2 className="text-lg font-semibold mb-4">Privacy Centre</h2>
                                <button
                                    className="absolute top-8 right-8 p-1 bg-[#09522869] rounded-full"
                                    onClick={() => setIsPrivacyOpen(!isPrivacyOpen)}
                                >
                                    <ChevronUp className={`h-4 w-4 text-[#095228] transition-transform ${isPrivacyOpen ? "rotate-0" : "rotate-180"}`} />
                                </button>
                                {isPrivacyOpen && (
                                    <>

                                        <div className="space-y-3">
                                            {[
                                                { label: "Phone Number", value: "+91 79043 30323" },
                                                { label: "Email ID", value: "praveenkumar@carmatec.in" },
                                                { label: "Who can see your friends list on your profile?" },
                                                { label: "Who can see the people, Pages and lists you follow?" },
                                                { label: "Who can see your future Feeds?" },
                                                { label: "Who can see your future Stories?" },
                                                { label: "Who can tag you?" },
                                                { label: "Who can see you're online?" },
                                            ].map((setting, index) => (
                                                <div
                                                    key={index}
                                                    className={`bg-white p-5 rounded-[12px] flex justify-between items-center shadow-sm ${setting.value ? "hidden sm:flex" : "flex"
                                                        }`}
                                                >
                                                    <div className="flex w-full justify-between">
                                                        <span className="text-[#494949]">{setting.label}</span>
                                                        {setting.value && (
                                                            <span className="text-black font-[400] text-[14px] flex">{setting.value} <span className="w-4 h-4 ml-2 bg-green-500 text-white rounded-full flex items-center justify-center">
                                                                <Check className="w-3 h-3" />
                                                            </span></span>
                                                        )}
                                                        <select className="text-black font-medium bg-transparent border-none outline-none">
                                                            <option>Public</option>
                                                            <option>Only me</option>
                                                            <option>Friends</option>
                                                        </select>
                                                    </div>

                                                </div>
                                            ))}
                                        </div>

                                    </>
                                )}
                            </div>
                            {/* Privacy Policy Section */}
                            <div className="mt-6 p-8 bg-[#F4F4F4] rounded-2xl shadow-lg relative">
                                <h2 className="text-lg font-semibold mb-4">Privacy Policy</h2>
                                <button
                                    className="absolute top-8 right-8 p-1 bg-[#09522869] rounded-full"
                                    onClick={() => setIsPolicyOpen(!isPolicyOpen)}
                                >
                                    <ChevronUp className={`h-4 w-4 text-[#095228] transition-transform ${isPolicyOpen ? "rotate-0" : "rotate-180"}`} />
                                </button>
                                {isPolicyOpen && (
                                    <>

                                        <div className="space-y-3">
                                            <AccordionItem title="Privacy Policy " className="rounded-[12px] bg-white">
                                                <p className="text-gray-500">Your activity and information you provide are protected under our privacy policy. We ensure your data remains safe and secure.</p>
                                            </AccordionItem>
                                            <AccordionItem title="Who can see your friends list?" className="rounded-[12px] bg-white">
                                                <p className="text-gray-500">You can control who can see your friends list on your profile.</p>
                                            </AccordionItem>
                                            <AccordionItem title="Who can tag you?" className="rounded-[12px] bg-white">
                                                <p className="text-gray-500">Choose who can tag you in their posts and comments.</p>
                                            </AccordionItem>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                        {/* <Viewpost /> */}
                        <RightResponsivesidebar />
                    </div>
                    {/* Right Sidebar */}
                    <Rightsidebar />

                </main>
            </main>
        </div >
    );
}
